// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__20jlM","checkbox":"Checkbox_checkbox__2DiPf","icon":"Checkbox_icon__3VOaM"};